import client from 'enrollment-platform/api/eps.client'
import { useMemo, useState } from 'react'

const csvName = 'Linear BER attached'

export const useDownloadArtifactReport = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false)

  const artifactId = useMemo(() => {
    const linearData = data?.find((_data) => _data.children === csvName)
    return linearData?.artifactId
  }, [data])

  const downloadArtifactCSV = async (
    syncId: number,
    artifactId: number
  ): Promise<void> => {
    setIsLoading(true)
    try {
      const response = await client.get(
        `/payroll/manual/${syncId}/artifact/${artifactId}`
      )

      if (response.status !== 200) {
        throw new Error('Failed to download artifact report')
      }

      // Handle different response types
      const csvData = response.data

      // Create blob from CSV string
      const blob = new Blob([csvData], {
        type: 'text/csv;charset=utf-8;',
      })

      // Create download link from blob
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Linear BER.csv`
      link.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading artifact report:', error)
    }
    setIsLoading(false)
  }

  return {
    downloadArtifactCSV,
    artifactId,
    isLoading,
    csvName,
  }
}
